<template>
  <div>
    <PageTitle pageTitle="My Profile" subTitle="Error" />
    <v-row class="pa-4">
      <NavButton
        routeName="goToAccount"
        icon="mdi-account"
        @navigate="navigateTo"
        :active="isActiveRoute('goToAccount')"
        >Account</NavButton
      >
      <NavButton
        routeName="goToAccountSecurity"
        icon="mdi-shield-lock"
        @navigate="navigateTo"
        :active="isActiveRoute('goToAccountSecurity')"
        >Security</NavButton
      >
      <NavButton
        routeName="goToImages"
        icon="mdi-image"
        @navigate="navigateTo"
        :active="isActiveRoute('goToImages')"
        >Image</NavButton
      >
      </v-row>
      <router-view></router-view>
        <v-row>
          <ProfileDetail />
        </v-row>
    <!--<div class="row">
      <div class="col-xxl-3">
        <div class="row">
          <div class="col-xxl-12 col-md-6 col-lg-4
            <ProfileIntro />
          </div>
          <div class="col-xxl-12 col-md-6 col-lg-4">
            <ProfileInformation />
          </div>
          <div class="col-xxl-12 col-md-6 col-lg-4">
            <AdditionalInformation />
          </div>
        </div>
      </div>

    </div>-->
  </div>
</template>

<script setup>
import { defineComponent } from "vue";
import WelcomeBack from "./WelcomeBack.vue";
import TotalProjects from "./TotalProjects.vue";
import TotalOrders from "./TotalOrders.vue";
import TotalRevenue from "./TotalRevenue.vue";
import ProfileIntro from "./ProfileIntro.vue";
import ProfileInformation from "./ProfileInformation.vue";
import AdditionalInformation from "./AdditionalInformation.vue";
import ProjectsAnalysisChart from "./ProjectsAnalysisChart.vue";
import ToDoList from "./ToDoList.vue";
import RecentActivity from "./RecentActivity.vue";
import ProfileDetail from "@/components/Others/MyProfile/ProfileDetail.vue";
import NavButton from "@/components/Others/MyProfile/NavButton.vue";
// import ProfileDetail from "../components/Others/MyProfile/ProfileDetail.vue"; 
import { useRouter,useRoute } from 'vue-router';
import PageTitle from "@/components/Common/PageTitle.vue";
const router = useRouter();
const route = useRoute();



const navigateTo = (routeName) => {
  router.push({ name: routeName });
};
// Function to check if the current route is active
const isActiveRoute = (routeName) => {
  return route.name === routeName;
};



</script>
